import { ActionType, createReducer } from 'typesafe-actions';

import * as actions from './nps.action';
import * as actionTypes from './nps.actionTypes';
import { NPSState } from './type';

export type NPSAction = ActionType<typeof actions>;

const initialState: NPSState = {
  isEligible: false,

  // Lite trigger
  isTriggering: false,
  triggerError: null,

  // Lite questionnaire
  questionnaire: null,
  isQuestionnaireLoading: false,
  questionnaireError: null,

  // Modal
  isModalOpen: false,

  // Submit / Dismiss
  isSubmitting: false,
  submitError: null,
  isDismissing: false,
  dismissError: null,

  // Session
  triggerSource: null,
  startDateTime: null
};

export const npsReducer = createReducer<NPSState, NPSAction>(initialState)
  // Lite trigger
  .handleAction(actions.npsTriggerAsync.request, (state, action) => ({
    ...state,
    isTriggering: true,
    triggerError: null,
    triggerSource: action.payload.triggerSource,
    startDateTime: action.payload.startDateTime
  }))
  .handleAction(actions.npsTriggerAsync.success, (state, action) => ({
    ...state,
    isTriggering: false,
    isEligible: action.payload.isEligible,
    triggerError: null
  }))
  .handleAction(actions.npsTriggerAsync.failure, (state, action) => ({
    ...state,
    isTriggering: false,
    triggerError: action.payload.error
  }))

  // Lite questionnaire
  .handleAction(actions.npsQuestionnaireAsync.request, state => ({
    ...state,
    isQuestionnaireLoading: true,
    questionnaireError: null
  }))
  .handleAction(actions.npsQuestionnaireAsync.success, (state, action) => ({
    ...state,
    isQuestionnaireLoading: false,
    questionnaire: action.payload.questionnaire
  }))
  .handleAction(actions.npsQuestionnaireAsync.failure, (state, action) => ({
    ...state,
    isQuestionnaireLoading: false,
    questionnaireError: action.payload.error
  }))

  // Modal
  .handleAction(actionTypes.NPS_OPEN_MODAL as any, state => ({ ...state, isModalOpen: true }))
  .handleAction(actionTypes.NPS_CLOSE_MODAL as any, state => ({ ...state, isModalOpen: false }))

  // Submit
  .handleAction(actions.npsSubmitAsync.request, state => ({ ...state, isSubmitting: true, submitError: null }))
  .handleAction(actions.npsSubmitAsync.success, state => ({ ...state, isSubmitting: false, isModalOpen: false }))
  .handleAction(actions.npsSubmitAsync.failure, (state, action) => ({
    ...state,
    isSubmitting: false,
    submitError: action.payload.error
  }))

  // Dismiss
  .handleAction(actions.npsDismissAsync.request, state => ({ ...state, isDismissing: true, dismissError: null }))
  .handleAction(actions.npsDismissAsync.success, state => ({ ...state, isDismissing: false, isModalOpen: false }))
  .handleAction(actions.npsDismissAsync.failure, (state, action) => ({
    ...state,
    isDismissing: false,
    dismissError: action.payload.error
  }))

  // Session
  .handleAction(actionTypes.NPS_RESET_SESSION as any, state => ({
    ...state,
    isEligible: false,
    isTriggering: false,
    triggerError: null,
    questionnaire: null,
    isQuestionnaireLoading: false,
    questionnaireError: null,
    isModalOpen: false,
    isSubmitting: false,
    submitError: null,
    isDismissing: false,
    dismissError: null,
    triggerSource: null,
    startDateTime: null
  }))
  .handleAction(actionTypes.NPS_SET_TRIGGER_SOURCE as any, (state, action: any) => ({
    ...state,
    triggerSource: action.payload.source
  }))
  .handleAction(actionTypes.NPS_SET_START_DATETIME as any, (state, action: any) => ({
    ...state,
    startDateTime: action.payload.dateTime
  }));
